import { Component, Input, OnInit, Output, EventEmitter, inject } from "@angular/core";
import { MasterDataService } from "src/app/services";
import { BehaviorSubject, Observable } from "rxjs";
import { FormControl } from "@angular/forms";
import { map, startWith, tap } from "rxjs/operators";
import { AnlageGroupListDto } from "src/app/web-api/web-api";

@Component({
    selector: "app-anlage-group-select",
    templateUrl: "./anlage-group-select.component.html",
    styleUrls: ["./anlage-group-select.component.scss"],
    standalone: false
})
export class AnlageGroupSelectComponent implements OnInit {
    private _md = inject(MasterDataService);

    private _selectedItem = "";
    filterCtl = new FormControl();

    @Input() isMultiselect = false;
    @Input() set selectedItem(value: string) {
        this._selectedItem = value;

        if (this.filterCtl) {
            this.filterCtl.setValue(value);
        }
    }

    @Input() allowCustomValue = false;
    @Input() placeholder = "Anlagegruppe";
    @Output() selectedItemChange = new EventEmitter<string>();

    public data: Array<string> = [];
    public searchFilter = new BehaviorSubject<string>("");
    filteredOptions: Observable<any>;

    ngOnInit() {
        this._md.Anlagen.GetAnlageGroups(this.searchFilter)
            .pipe(
                tap(
                    (results: AnlageGroupListDto) => {
                        this.data = results.data.map(x => x.groupName);
                        this.filteredOptions = this.filterCtl.valueChanges.pipe(
                            startWith(''),
                            map(value => this._filter(value))
                        );
                    }
                ))
            .subscribe({
                error: (err) => console.error(err)
            })
    }

    private _filter(name: string): string[] {
        const filterValue = name.toLowerCase();

        return this.data.filter(option => option.toLowerCase().includes(filterValue));
    }

    public OnValueChange(event) {
        this.selectedItemChange.emit(event.option.value);
    }
}
